<bricks-modal (closeDialog)="closeDialog()">
  <bricks-modal-header> Wie nutzen Sie den Batterie-Speicher? </bricks-modal-header>
  <bricks-modal-body>
    <p><b>Eigenverbrauchsoptimierung</b></p>
    <p>
      Der Batteriespeicher wird ausschließlich zur Einspeicherung von überschüssigem PV-Erzeugungsstrom genutzt, welcher
      dann zum Decken des Eigenverbrauchs in erzeugungsschwachen Phasen wieder ausgespeichert wird.
    </p>
    <p class="gray">Es erfolgt keine Netzeinspeisung aus dem Speicher.</p>
    <br />
    <p><b>Peak-Shaving / Lastspitzenkappung</b></p>
    <p>
      Der Speicher wird dazu genutzt Verbrauchsspitzen zu kappen, d.h. diese während Spitzenlastzeiten nicht aus dem
      Netz zu beziehen, sondern stattdessen auf den Batteriespeicher zurückzugreifen.
    </p>
    <p class="gray">Es erfolgt keine Netzeinspeisung aus dem Speicher.</p>
    <br />
    <p><b>Atypische Netznutzung</b></p>
    <p>
      Bei der Atypischen Netznutzung wird mit dem Verteilnetzbetreiber ein Verschieben des Lastprofils mit Hilfe des
      Speichers vereinbart. Meist um die Abnahme zu Spitzenlastzeiten zu vermeiden und Netzentgelte einzusparen.
    </p>
    <p class="gray">Es erfolgt keine Netzeinspeisung aus dem Speicher.</p>
    <br />
    <p><b>Marktdienlicher Einsatz / Arbitrage</b></p>
    <p>
      Der Speicher wird gezielt dazu genutzt, Energie aus dem Netz und/oder der Erzeugungsanlage in Niedrigpreis-Phasen
      einzuspeichern und zu teuren Preisen wieder ins Netz auszuspeisen, um Arbitrage zu erzielen.
    </p>
    <p class="gray">
      Eine Netzeinspeisung aus dem Speicher findet somit statt. Dies geschieht unabhängig von Eigenverbrauch oder
      anderen Abnehmern.
    </p>
  </bricks-modal-body>
  <bricks-modal-footer>
    <button class="bricks-button button-primary button-fn" (click)="closeDialog()">
      <span>Schließen</span>
    </button>
  </bricks-modal-footer>
</bricks-modal>
